var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wishlist"},[_c('SfTabs',{attrs:{"open-tab":1}},[_c('SfTab',{attrs:{"title":_vm.$t('Shopping List')}},[_c('ShoppingList',{attrs:{"list":_vm.shoppingList}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }